import Vue from 'vue';
import Vuex from 'vuex';
import VuexPersistence from 'vuex-persist';

import app from './app';
import user from './user';
import entities from './entities';
import competitions from './competitions';
import members from './members';
import teamRegos from './team-regos';
import events from './events';
import ladders from './ladders';
import matches from './matches';
import scheduler from './scheduler';
import memberships from './memberships';
import entityMemberships from './entity-memberships';
import national from './national';
import page from './page';
import tagGroups from './tag-groups';
import saleableItems from './saleable-items';
import teamMatches from './team-matches';
import accreditations from './accreditations';
import indvCompetitions from './indv-competitions';
import indvMatches from './indv-matches';
import indvScheduler from './indv-scheduler';
import appointmentBoards from './appointment-boards';
import referees from './referees';
import widgets from './widgets';
import season from './season';
import discount from './discount';
import incidents from './incidents';
import reports from './reports';
import fixtureExplorer from './fixture-explorer';
import emailHistories from './email-histories';
import dashboard from './dashboard';

Vue.use(Vuex);

const vuexLocal = new VuexPersistence({
  key: 'assemble-sports-user',
  storage: window.localStorage,
  modules: [
    'app',
    'national',
    'user',
    'season',
    'page',
    'matches',
    'indvMatches',
    'dashboard',
    'competitions',
    'scheduler',
  ],
});

export default new Vuex.Store({
  state: {
    rootLoading: false,
    loginRedirect: undefined,
  },
  mutations: {
    loading(state, update) {
      state.rootLoading = update;
    },
    loginRedirect(state, payload) {
      state.loginRedirect = payload;
    },
  },
  actions: {
  },
  getters: {
    loading: (state) => state.rootLoading,
  },
  modules: {
    app,
    user,
    entities,
    competitions,
    events,
    ladders,
    matches,
    scheduler,
    memberships,
    teamRegos,
    members,
    entityMemberships,
    national,
    page,
    tagGroups,
    teamMatches,
    accreditations,
    indvCompetitions,
    indvMatches,
    indvScheduler,
    appointmentBoards,
    referees,
    widgets,
    season,
    discount,
    fixtureExplorer,
    saleableItems,
    incidents,
    reports,
    emailHistories,
    dashboard,
  },
  plugins: [vuexLocal.plugin],
});
